export class MiddlewareRunner {
    #middlewareList = [];
    [Symbol.iterator]() {
        return this.#middlewareList.values();
    }
    get length() {
        return this.#middlewareList.length;
    }
    has(...targetEntry) {
        return this.#middlewareList.some((entry) => {
            const [kind, middleware] = entry;
            const [targetKind, targetMiddleware] = targetEntry;
            return kind === targetKind && middleware === targetMiddleware;
        });
    }
    // NOTE: Decided to name this method `add` instead of `use` for consistency with `Map` and `Set`.
    // Additionally, this is intended to be a "Runner" rather than a typical middleware handler,
    // so `add` seems more appropriate.
    add(...entry) {
        if (this.has(...entry)) {
            const [kind, middleware] = entry;
            console.warn(`Middleware already exists: [${kind}, ${middleware.name}]`);
            return;
        }
        this.#middlewareList.push(entry);
    }
    remove(...targetEntry) {
        const indexToRemove = this.#middlewareList.findIndex((entry) => {
            const [kind, middleware] = entry;
            const [targetKind, targetMiddleware] = targetEntry;
            return kind === targetKind && middleware === targetMiddleware;
        });
        if (indexToRemove !== -1) {
            this.#middlewareList.splice(indexToRemove, 1);
        }
    }
    async forEach(targetKind, handler) {
        // Copy middleware list to prevent issues from modifications during iteration.
        const list = [...this.#middlewareList];
        for (const entry of list) {
            const [kind, middleware] = entry;
            if (kind !== targetKind)
                continue;
            await handler(middleware);
        }
    }
    async chain(targetKind, initialValue) {
        let result = initialValue;
        await this.forEach(targetKind, async (middleware) => {
            result = (await middleware(result)) ?? result;
        });
        return result;
    }
}
